export default __webpack_public_path__ + "static/media/remeratienda.c023ddd0.png";